
import React, { useEffect, useState } from 'react';
import './HelpAndSupport.css'
import { useSelector } from 'react-redux';
import { getAllTIcketList, getMessageApi } from '../../api';
import CommonTicket from '../../common/ticket/CommonTicket';
import { toast } from 'react-toastify';



const ClosedTicket = () => {

  const token = useSelector((state) => state?.user?.user?.token); 
  const [closedTicketData,setClosedTicketData]=useState([])
  const [loading,setLoading]=useState(false);
  // const [searchQuery, setSearchQuery] = useState("")
  const [myTimout,setMyTimeOut]=useState();
  const [currentPage,setCurrentPage]=useState(1);
  const [totalPages,setTotalPages]=useState(1);



  // const handleSearchChange = (newQuery) => {
  //   setSearchQuery(newQuery);
  // };
  



  const handleAllClosedChat=async()=>{
    try {
      let status="Closed";
       if(currentPage===1){
        setLoading(true);
      }
      const response = await getAllTIcketList({
        token,
        // searchQuery,
        status ,
        currentPage,
        limit:10
      });
      // setAllTicketData(response?.tickets|| []);
      setClosedTicketData((prevTickets) => [...prevTickets, ...response?.tickets]);

      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  useEffect(()=>{
    handleAllClosedChat(currentPage)
  },[currentPage])


  // useEffect(() => {
  //   if(searchQuery.trim()!=""){
  //     clearTimeout(myTimout);
  //     setMyTimeOut(setTimeout(handleAllClosedChat, 500));
  //   }
  // }, [searchQuery]);

 


  const loadMoreTickets = () =>{
    if(currentPage<totalPages){
      setCurrentPage((prevPage) => prevPage + 1);
    }
}
const hasMoreTickets = currentPage < totalPages;


  return (
    <CommonTicket
      AllTicket={closedTicketData}
      loadMore={loadMoreTickets}
      hasMore={hasMoreTickets}
      loading={loading}
    />
  );
};

export default ClosedTicket;
